import React, { useEffect, useMemo, useState } from "react";

export default function CityPicker({
  value,
  onChange,
  locale,
  acc,
  inputStyle,
  placeholder,
  maxVisibleItems = 4,
  disabled = false,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const [cityOptionsResolver, setCityOptionsResolver] = useState(null);
  const [hoveredOption, setHoveredOption] = useState(null);

  useEffect(() => {
    let cancelled = false;
    import("../features/locations/cities")
      .then((mod) => {
        if (!cancelled) setCityOptionsResolver(() => mod.getBirthplaceCityOptions);
      })
      .catch(() => {
        if (!cancelled) setCityOptionsResolver(() => null);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const filteredCityOptions = useMemo(() => {
    if (!cityOptionsResolver) return [];
    return cityOptionsResolver({
      locale,
      query: value,
      limit: 20,
    });
  }, [cityOptionsResolver, locale, value]);

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onFocus={() => {
          if (disabled) return;
          setIsFocused(true);
        }}
        onBlur={() => {
          window.setTimeout(() => setIsFocused(false), 120);
        }}
        style={inputStyle}
        placeholder={placeholder}
        autoComplete="off"
        disabled={disabled}
      />
      {!disabled && isFocused && filteredCityOptions.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            left: 0,
            right: 0,
            zIndex: 8,
            maxHeight: maxVisibleItems * 38,
            overflowY: "auto",
            borderRadius: 12,
            background: "rgba(8, 13, 32, 0.98)",
            border: `1px solid ${acc.primary}33`,
            boxShadow: `0 12px 36px rgba(0,0,0,0.45), 0 0 18px ${acc.primary}22`,
            backdropFilter: "blur(12px)",
          }}
        >
          {filteredCityOptions.map((city) => {
            const isHovered = hoveredOption === city.name;
            return (
              <button
                key={city.name}
                type="button"
                onMouseDown={() => {
                  onChange(city.name);
                  setIsFocused(false);
                }}
                onMouseEnter={() => setHoveredOption(city.name)}
                onMouseLeave={() => setHoveredOption(null)}
                style={{
                  width: "100%",
                  textAlign: "left",
                  padding: "9px 12px",
                  border: "none",
                  cursor: "pointer",
                  fontFamily: "'DM Sans',sans-serif",
                  fontSize: 13,
                  color: isHovered ? "#ffffff" : "#d9def7",
                  background: isHovered ? `linear-gradient(135deg, ${acc.primary}44, ${acc.tertiary}33)` : "transparent",
                  borderBottom: "1px solid rgba(255,255,255,0.06)",
                  transition: "all 0.15s ease",
                }}
              >
                {city.name}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
